import { AUTH_TOKEN_KEY, USER_ACCESS_KEY, USER_INFO_KEY, API_PATH, PUBLIC_REQUEST_KEY } from 'constants/common.constant';
import { RemoveLocalStorage, SetLocalStorage } from 'utils/common';
import fetch_ from 'interceptors/FetchInterceptor';
import {
  SIGNIN,
  AUTHENTICATED,
  SIGNOUT,
  SIGNOUT_SUCCESS,
  SHOW_AUTH_MESSAGE,
  HIDE_AUTH_MESSAGE,
  SIGNUP,
  SIGNUP_SUCCESS,
  SHOW_LOADING,
} from '../constants/Auth';

export const signIn = ({ user, accessToken, access }) => {
  SetLocalStorage(AUTH_TOKEN_KEY, accessToken);
  SetLocalStorage(USER_INFO_KEY, user);
  SetLocalStorage(USER_ACCESS_KEY, access);
  return {
    type: AUTHENTICATED,
    token: accessToken,
    userInfo: user,
    userAccess: access,
  }
};

export const authenticated = (token) => {
  return {
    type: AUTHENTICATED,
    token
  }
};

export const signOut = () => {
  RemoveLocalStorage(AUTH_TOKEN_KEY)
  RemoveLocalStorage(USER_INFO_KEY)
  RemoveLocalStorage(USER_ACCESS_KEY)
  RemoveLocalStorage("formFields")
  return {
    type: SIGNOUT
  };
};

export const signOutSuccess = () => {
  return {
    type: SIGNOUT_SUCCESS,
  }
};

export const signUp = (user) => async (dispatch) => {
  try {
    const data = {
      email: user.email,
      password: user.password,
      firstName: user.firstName || user.email.split('@')[0],
      ...user
    };

    // Only include optional fields if they have valid values
    if (user.phoneNumber) data.phoneNumber = user.phoneNumber;
    if (user.type) data.type = user.type;
    if (user.provider) data.provider = user.provider;
    if (user.bio) data.bio = user.bio;

    const response = await fetch_({
      url: API_PATH.BUSINESS_USER_REGISTER,
      method: 'POST',
      headers: {
        [PUBLIC_REQUEST_KEY]: true
      },
      data
    });

    if (response.data && response.data.token) {
      dispatch(signUpSuccess(response.data.token));
      return;
    }

    dispatch(showAuthMessage(response.data?.message || 'Signup failed'));
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Signup failed';
    dispatch(showAuthMessage(errorMessage));
  }
};

export const signUpSuccess = (token) => {
  return {
    type: SIGNUP_SUCCESS,
    token
  };
};

export const showAuthMessage = (message) => {
  return {
    type: SHOW_AUTH_MESSAGE,
    message
  };
};

export const hideAuthMessage = () => {
  return {
    type: HIDE_AUTH_MESSAGE,
  };
};

export const showLoading = (loading = true) => {
  return {
    type: SHOW_LOADING,
    data: loading
  };
};
